import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            探索分类
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            六大核心频道，全方位覆盖男同生活所需
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat) => {
            const colorMap: Record<string, { bg: string; text: string; hoverBg: string }> = {
              primary: { bg: 'bg-primary-50', text: 'text-primary-700', hoverBg: 'hover:bg-primary-100' },
              accent: { bg: 'bg-accent-50', text: 'text-accent-700', hoverBg: 'hover:bg-accent-100' },
              secondary: { bg: 'bg-secondary-50', text: 'text-secondary-700', hoverBg: 'hover:bg-secondary-100' },
            };
            const colors = colorMap[cat.color] || colorMap.primary;

            return (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`group p-5 md:p-6 rounded-lg ${colors.bg} border border-transparent hover:border-primary-200 transition-all duration-300 cursor-pointer`}
              >
                <div className={`w-12 h-12 flex items-center justify-center rounded-lg ${colors.bg} ${colors.text} mb-4 group-hover:scale-110 transition-transform duration-300`}>
                  <i className={`${cat.icon} text-2xl`}></i>
                </div>
                <h3 className="text-lg font-semibold text-foreground-900 mb-2">
                  {cat.name}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-3">
                  {cat.description}
                </p>
                <span className="text-xs text-foreground-400">
                  {cat.articleCount} 篇文章
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}